import { render, staticRenderFns } from "./AppReportsLayout.vue?vue&type=template&id=951bece8&"
import script from "./AppReportsLayout.vue?vue&type=script&lang=ts&"
export * from "./AppReportsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports